






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Package extends Vue {
}
